export const Tags = {
	PrimaryLight: 'primaryLight',
	Primary: 'primary',
	SecondaryLight: 'secondaryLight',
	Warning: 'warning',
	Alert: 'alert',
	Dark: 'dark',
} as const;
